import { Grid, Section } from '@farmersdog/corgi-x';

import { HeroIconItemsMobile, HeroImage, HeroTitle } from '../../components';
import { useTrackedSectionRef } from '../../../../../../hooks/useTrackedSections';
import { HomepageRedesignSections } from '../../../CtaTrackerV2';

import { heroOlsVariantSources } from '../OlsHero/assets';

import styles from './VetsNegativeHero.module.css';

export const VetsNegativeHero = () => {
  const sectionRef = useTrackedSectionRef(HomepageRedesignSections.Hero);

  return (
    <Section sectionRef={sectionRef} aria-label="Homepage Hero">
      <div className={styles.pageHeroWrapper}>
        <Grid className={styles.heroContent}>
          <HeroTitle />
        </Grid>
      </div>
      <HeroImage objectPosition="50% 10%" sources={heroOlsVariantSources} />
      <div className={styles.heroIconItemsContainer}>
        <HeroIconItemsMobile />
      </div>
    </Section>
  );
};
